// shown-slided-content.js
; (({ $, $$ }) => {
    const openedClass = 'js-shown-slided-content_opened'

    $$(".js-shown-slided-content").forEach(content => {
        const mode = content.dataset.mode || 'toggle'
        const container = content.querySelector('.js-shown-slided-content__container')
        const trigger = content.querySelector('.js-shown-slided-content__trigger')
        const originalTriggerText = trigger.innerHTML
        const toggledTriggerText = trigger.dataset.toggledText
        let hidden = true

        trigger.addEventListener('click', event => {
            event.preventDefault()

            if (mode == 'toggle') {
                container.slideToggle()
                hidden = !hidden
                trigger.parentNode.classList.toggle(openedClass)
                trigger.innerText = hidden ? originalTriggerText : toggledTriggerText
            }
        })
    })
})(CNS);



; (({ $, $$ }) => {
    const groupOpenedClass = 'js-shown-slided-content-v2_opened'
    const triggerOpenedClass = 'js-shown-slided-content-v2__trigger_opened'

    $$(".js-shown-slided-content-v2").forEach(group => {
        const mode = group.dataset.mode || 'toggle'
        const container = group.querySelector('.js-shown-slided-content-v2__container')
        const trigger = group.querySelector('.js-shown-slided-content-v2__trigger')
        const label = group.querySelector('.js-shown-slided-content-v2__label')
        const originalTriggerText = label.innerHTML
        const toggledTriggerText = trigger.dataset.toggledText
        let hidden = true

        trigger.addEventListener('click', event => {
            event.preventDefault()

            if (mode == 'toggle') {
                container.slideToggle()
                hidden = !hidden
                group.classList.toggle(groupOpenedClass)
                trigger.classList.toggle(triggerOpenedClass)
                label.innerText = hidden ? originalTriggerText : toggledTriggerText
            }
        })
    })
})(CNS);